// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgotPasswordForm-container {
  min-height: calc(100vh - 50px);
  background-color: #f3f3ea;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/forgot-password/forgot-password.component.scss"],"names":[],"mappings":"AACA;EACE,8BAAA;EAEA,yBAAA;AADF","sourcesContent":["\r\n.forgotPasswordForm-container{\r\n  min-height: calc(100vh - 50px);\r\n //  background-color: #fbf9ec;\r\n  background-color: #f3f3ea;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
